import { apiClient } from "../api/ApiClient";
import { hash } from "../utils/Util";
import type { KeyValue } from "../models/KeyValue";
import type { SystemUser } from "../models/SystemUser";
import { CreateCrudService } from "./CrudServiceFactory";

export function UserService() {
  const crud = CreateCrudService<SystemUser, KeyValue>({
    Route: "authentication",
    EntityName: "User",
    DeleteAction: "DeleteUser",
    SaveRequest: async (rows) => {
      const data = await Promise.all(
        rows.map(async (value) => {
          const {Roles, ...item} = value as SystemUser;
          if (item.DataState === "New")
            return {
              ...item,
              IsTenantAdmin: false,
              Password: await hash(item.Password),
            };
          const { Password, ...changes } = item;
          return changes;
        }),
      );
      const saved = (
        await apiClient.post<SystemUser[]>("authentication/SaveUser", data, {
          busyMessage: "Saving user...",
        })
      ).data;
      return saved.map(user=>({...user,RoleCodes:user.RoleCodes ?? user.Roles?.map(r=>r.Code) ?? []}));
    },
    PartialFields: ["FirstName", "LastName", "Email", "Code"],
    LoadingMessage: "Loading users...",
    SavingMessage: "Saving user...",
    MapPartial: (value) => ({
      Key: String(value.Code ?? ""),
      Value:
        `${String(value.FirstName ?? "")} ${String(value.LastName ?? "")}`.trim(),
    }),
  });
  const normalize = (page: import("../models/PagedResult").PagedResult<SystemUser>) => ({...page,Data:page.Data.map(user=>({...user,RoleCodes:user.RoleCodes?.length?user.RoleCodes:user.Roles?.map(r=>r.Code)??[]}))});
  return {...crud,GetAll:async(skip?:number,limit?:number)=>normalize(await crud.GetAll(skip,limit)),SearchByAnyParam:async(text:string,skip?:number,limit?:number)=>normalize(await crud.SearchByAnyParam(text,skip,limit))};
}
